<app-modal class="add-edit-event-modal">
  <h1 class="h2">Edit Event</h1>
  <div class="mt-0100 mb-0025">
    <app-event-form #eventFormRef class="d-block" [calendarEvent]="calendarEvent"
      (calendarEventUpdated)="calendarEventUpdated($event)">
    </app-event-form>

    <app-an-event-sync-options #eventSyncComponent [calendarEvent]="calendarEvent">
    </app-an-event-sync-options>

    <app-error-notification [errors]="errorMessages"></app-error-notification>

    <div class="row dual-btn-row with-gap mt-0100 flexJustify--end">
      <button type="button" class="btn btn--white" (click)="close()">
        Cancel
      </button>
      <button type="button" class="btn mt-0" (click)="saveClicked()" [disabled]="isSubmitting">
        Save changes
      </button>
    </div>

  </div>
</app-modal>
